import {
  DataProvider,
  IErrorModel,
  InvoiceStatus,
  TimeHelper,
  useCurrentUserSelector,
  useQuery,
} from "@nf/common";

const MONTHS_OF_HISTORY = 12;

const getPaymentInvoices = async () => {
  const invoices = await DataProvider.getPaymentInvoices(
    TimeHelper.getStartOfDayMonthsAgo(MONTHS_OF_HISTORY)
  );
  return invoices.filter((invoice) => invoice.Status !== InvoiceStatus.Failed);
};

export const usePaymentInvoices = () => {
  const userId = useCurrentUserSelector()?.Id;

  const { data, error, isLoading } = useQuery(
    `payment-invoices-${userId}`,
    getPaymentInvoices,
    { enabled: !!userId }
  );

  return {
    invoices: data ?? undefined,
    error: (error ?? undefined) as IErrorModel | undefined,
    isLoading: isLoading || !userId,
  };
};
